import React, { useState, useEffect, useRef } from "react";
import UploadModal from "../../components/Modals/bulk-repayment/UploadModal";
import { toast } from "react-toastify";
import SuccessModal from "../../components/Modals/bulk-repayment/SuccessModal";
import { useNavigate } from "react-router-dom";
import { client } from "../../sdk/client/client";
import UploadFailedModal from "../../components/Modals/bulk-repayment/UploadFailedModal";

const IntroBulk = () => {
  const [photoFile, setPhotoFile] = useState(null);
  const [isUploadEnabled, setIsUploadEnabled] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showUploadFailed, setShowUploadFailed] = useState(false);
  const [uploadResponse, setUploadResponse] = useState(null);
  const fileInputFront = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    setIsUploadEnabled(photoFile !== null);
  }, [photoFile]);

  const handlePhotoFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.name.endsWith(".csv")) {
      setPhotoFile(file);
    } else {
      setPhotoFile(null);
    }
  };

  const handleFileUpload = async () => {
    if (!photoFile) {
      toast.error("No file selected. Please choose a CSV file.");
      return;
    }

    setIsUploading(true);

    try {
      const response = await uploadFile(photoFile);

      console.log("Upload response:", response);
      setTimeout(() => {
        if (response?.statusCode === 201) {
          setUploadResponse(response);
          localStorage.setItem(
            "bulkRepaymentData",
            JSON.stringify(response?.data),
          );
          setShowSuccessModal(true);
          toast.success("File uploaded successfully!");
        } else {
          throw new Error(response?.message || "Unexpected response");
        }

        setIsUploading(false);
      }, 4000);
    } catch (error) {
      console.error("File upload failed:", error);
      toast.error(error.message || "Error uploading file. Please try again.");
      setTimeout(() => {
        setShowUploadFailed(true);
        setIsUploading(false);
      }, 4000);
    }
  };

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await client.post(
        "/api/v1/loan/verify-deductions",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error;
    }
  };

  const handleCloseFailedModal = () => setShowUploadFailed(false);

  return (
    <>
      <div className="mx-auto w-full bg-[#F5F6F7] h-full overflow-y-auto">
        <h2 className="text-2xl font-semibold mb-4  px-2  text-[#005C53]">
          Bulk Payments
        </h2>

        <div className="bg-[#FFFFFF] px-2 justify-center w-[99%] border boreder-[#DCDCDC] mx-auto rounded-[15px]">
          <h1 className="text-[16px] font-[500] text-[#005C53] mt-2 mb-1">
            Upload Bulk Payment
          </h1>
          <p className="text-[#000000] text-[14px] font-[400] mb-1">
            Upload a CSV file to update offline repayments for shares, savings,
            and loan repayments, including Check-off, Flash, and Emergency
            loans. Upload a CSV file with
          </p>
          <p className="text-g[#000000] mb-1">
            the repayment details. Make sure your file adheres to the required
            format. Check out -{">"}
            {"  "}
            <a
              href="https://anansi-dev.s3.eu-west-1.amazonaws.com/05d1a10b-af00-4995-a3d5-a8cda788c95f-BulkProcessingCSV.csv"
              download
              className="text-[#316CE9] underline"
            >
              sample.csv{"  "}
            </a>
            to check the required formatting.
          </p>

          <div className="mx-auto items-center">
            <div className="flex flex-col justify-center items-center mt-8 mb-5">
              <div
                onClick={() => fileInputFront.current?.click()}
                className="w-[70%] max-w-md h-[162px] rounded-[5px] bg-[#FAFAFA] border border-dashed border-black flex items-center justify-center flex-col cursor-pointer"
              >
                <svg
                  width="45"
                  height="45"
                  viewBox="0 0 45 45"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.5625 29.2069V12.9881L17.1938 17.3569L15.8663 16.0106L22.5 9.375L29.1356 16.0106L27.8081 17.3588L23.4375 12.9881V29.2069H21.5625ZM12.405 35.625C11.5413 35.625 10.8206 35.3363 10.2431 34.7588C9.66562 34.1812 9.37625 33.46 9.375 32.595V28.0519H11.25V32.595C11.25 32.8838 11.37 33.1488 11.61 33.39C11.85 33.6313 12.1144 33.7512 12.4031 33.75H32.5969C32.8844 33.75 33.1488 33.63 33.39 33.39C33.6313 33.15 33.7512 32.885 33.75 32.595V28.0519H35.625V32.595C35.625 33.4588 35.3363 34.1794 34.7588 34.7569C34.1812 35.3344 33.46 35.6238 32.595 35.625H12.405Z"
                    fill="black"
                  />
                </svg>
                <input
                  type="file"
                  ref={fileInputFront}
                  onChange={handlePhotoFileChange}
                  accept=".csv"
                  style={{ display: "none" }}
                />
                <p className="text-[#000000] text-[16px] font-[500] text-center">
                  {!photoFile ? (
                    <>
                      Drag and Drop or{" "}
                      <span
                        style={{
                          color: "#316CE9",
                          textDecoration: "underline",
                        }}
                      >
                        Choose file
                      </span>{" "}
                      here
                      <p className="font-normal text-[14px] italic">
                        Make sure your file is in CSV format
                      </p>
                    </>
                  ) : (
                    photoFile.name
                  )}
                </p>
              </div>

              <button
                onClick={handleFileUpload}
                className="mt-3 px-6 py-2 w-[456px] h-[51px] bg-[#005C53] text-white rounded-md hover:bg-[#004742] transition"
                disabled={!isUploadEnabled}
              >
                Upload file
              </button>
            </div>
          </div>
        </div>
      </div>
      {isUploading && <UploadModal />}

      {showSuccessModal && (
        <SuccessModal
          response={uploadResponse}
          onContinue={() => {
            setShowSuccessModal(false);
            setPhotoFile(null);
            navigate("/dashboard/bulk-repayment/preview");
          }}
        />
      )}
      {showUploadFailed && (
        <UploadFailedModal
          handleCloseFailedModal={handleCloseFailedModal}
          onRetry={() => {
            setShowUploadFailed(false);
            setPhotoFile(null);
          }}
        />
      )}
    </>
  );
};

export default IntroBulk;
